"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = _interopRequireDefault(require("@concur/nui-widgets/lib/Buttons/Button"));
var _Spinner = _interopRequireDefault(require("@concur/nui-widgets/lib/Spinner/Spinner"));
var _nuiIntlRuntime = require("@concur/nui-intl-runtime");
var _listingModule = require("../../listingModule");
var _analytics = require("../../../constants/analytics");
var _styles = require("../styles");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// This renders the button for listings with
// .core.listingType value === ACONCT
// These are also known as "Enroll" listings.
function AconctListingConnectionSection(_ref) {
  var listing = _ref.listing,
    trackButtonClick = _ref.trackButtonClick,
    companyUUID = _ref.companyUUID,
    toggleModal = _ref.toggleModal,
    checkForConnection = _ref.checkForConnection,
    isDisabled = _ref.isDisabled,
    isConnecting = _ref.isConnecting;
  var ID = listing.ID,
    _listing$core = listing.core,
    isUserConnected = _listing$core.isUserConnected,
    listingName = _listing$core.listingName,
    v1ID = _listing$core.v1ID;
  function launchEnrollModal() {
    trackButtonClick({
      elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.button.enroll],
      dimensions: {
        listingId: ID,
        listingName: listingName,
        companyUUID: companyUUID
      }
    });
    toggleModal(_listingModule.ENROLL_MODAL);
    checkForConnection(ID, v1ID);
  }
  function launchUnenrollModal() {
    trackButtonClick({
      elementPath: [[_analytics.listingConst, listingName].join(' '), _analytics.button.unenroll],
      dimensions: {
        listingId: ID,
        listingName: listingName,
        companyUUID: companyUUID
      }
    });
    toggleModal(_listingModule.UNENROLL_MODAL);
    checkForConnection(ID, v1ID);
  }
  if (!isUserConnected) {
    return /*#__PURE__*/_react.default.createElement(_Button.default, {
      style: _styles.BUTTON_STYLE,
      innerProps: {
        className: 'max-button-width'
      },
      onClick: launchEnrollModal,
      disabled: isDisabled || isConnecting
    }, isConnecting ? /*#__PURE__*/_react.default.createElement(_Spinner.default, {
      size: "md",
      type: "inline",
      className: "spinner",
      message: " ",
      visible: true
    }) : /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
      id: "Enroll"
    }));
  }
  return /*#__PURE__*/_react.default.createElement(_Button.default, {
    style: _styles.BUTTON_STYLE,
    innerProps: {
      className: 'max-button-width'
    },
    onClick: launchUnenrollModal
  }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.FormattedMessage, {
    id: "Unenroll"
  }));
}
AconctListingConnectionSection.propTypes = {
  listing: _propTypes.default.shape({
    core: _propTypes.default.shape({
      v1ID: _propTypes.default.string.isRequired,
      isUserConnected: _propTypes.default.bool,
      listingName: _propTypes.default.string.isRequired
    }).isRequired,
    ID: _propTypes.default.string.isRequired
  }).isRequired,
  trackButtonClick: _propTypes.default.func.isRequired,
  companyUUID: _propTypes.default.string.isRequired,
  checkForConnection: _propTypes.default.func.isRequired,
  isDisabled: _propTypes.default.bool,
  toggleModal: _propTypes.default.func.isRequired,
  isConnecting: _propTypes.default.bool
};
var _default = exports.default = AconctListingConnectionSection;